import {get, post,postZip} from '@/utils/request'

const SERVICE_URL = '/quotation-service/v1'
const GENERAL_SERVICE_URL = '/general-service/v1'

/** 询价包 */
export function fetchRFQList(params) {
    console.log('fetchRFQList')
    return post(SERVICE_URL + '/quotation/listRfq', params)
}
export function getRFQDetail(params, pathParam) {
    return get(SERVICE_URL + '/quotation/getById', params, pathParam)
}
export function createRFQ(params) {
    return post(SERVICE_URL + '/quotation/insert', params)
}
export function editRFQ(params) {
    return post(SERVICE_URL + '/quotation/update', params)
}
export function deleteRFQ(params, pathParam) {
    return get(SERVICE_URL + '/quotation/delete', params, pathParam)
}
export function createMPRFQ(params) {
    return post(SERVICE_URL + '/quotation/createMPRfq', params)
}
export function createSpotFQ(params) {
    return post(SERVICE_URL + '/quotation/createSpotfq', params)
}
/** 零件列表 */
export function getRfqPartList(params) {
    return post(SERVICE_URL + '/part/list', params)
}

export function listPartCompare(params) {
    return post(SERVICE_URL + '/part/listPartCompare', params)
}

/** 零件列表 */
export function getRfqPartViewList(params) {
    return post(SERVICE_URL + '/partView/list', params)
}

/** 零件列表 */
export function getSupplierSummaryList(params) {
    return post(SERVICE_URL + '/supplierSummaryView/list', params)
}

/** 获取比较信息页中当前轮次对比数据，包括不是当前轮次的最终报价数据 */
export function queryCurrentRoundAndLastList(params) {
    return post(SERVICE_URL + '/supplierSummaryView/queryCurrentRoundAndLastList', params)
}

/** 供应商管理 */
export function getRfqSupplierList(params) {
    return post(SERVICE_URL + '/rfqSupplier/list', params)
}

/** 供应商管理 */
export function getRfqSupplierListB(params) {
    return post(SERVICE_URL + '/rfqSupplier/listB', params)
}

export function deleteRfqSupplier(params, pathParam) {
    return get(SERVICE_URL + '/rfqSupplier/delete', params, pathParam)
}

export function getRfqSupplierById(params, pathParam) {
    return get(SERVICE_URL + '/rfqSupplier/getById', params, pathParam)
}

export function getRfqSupplierByUserId(params, pathParam) {
    return get(SERVICE_URL + '/rfqSupplier/getByUserId', params, pathParam)
}

export function createRfqSupplier(params) {
    return post(SERVICE_URL + '/rfqSupplier/add', params)
}

export function createRfqSupplierBatch(params) {
    return post(SERVICE_URL + '/rfqSupplier/addBatch', params)
}

export function editRfqSupplier(params) {
    return post(SERVICE_URL + '/rfqSupplier/edit', params)
}

export function editRfqSupplierList(params) {
    return post(SERVICE_URL + '/rfqSupplier/editBatch', params)
}

/** 根据rfq和供应商获取rfq关联供应商信息 */
export function getRfqSupplierByRfqIdAndVenderId(params) {
    return get(SERVICE_URL + '/rfqSupplier/getRfqSupplierByRfqIdAndVenderId', params)
}

/**修改报价**/
export function editRfqPartPriceList(params) {
    return post(SERVICE_URL + '/quotation/editRfqPartPriceList', params)
}

/** 零件列审批表 */
export function getApplierSummaryAuditList(params) {
    return post(SERVICE_URL + '/supplierSummaryAuditView/list', params)
}

/** 零件列审批表 */
export function getRfqPartAuditViewList(params) {
    return post(SERVICE_URL + '/partAuditView/list', params)
}
/** 获取 采购工程师下拉选 接口 } /quotation/listEngineer*/
export function listEngineer(params) {
    return post(SERVICE_URL + '/quotation/listEngineer', params)
}
/** 获取当前登录人对应的采购组织 接口 } /position/getCurrentUserPurOrg*/
export function getCurrentUserPurOrg(params) {
    return get(GENERAL_SERVICE_URL + '/position/getCurrentUserPurOrg', params)
}

export function queryPage(params) {
    return post(SERVICE_URL + '/quotation/queryPage', params)
}
export function deleteZgPrice(params) {
    return post(SERVICE_URL + '/quotation/delete', params)
}

export function insertZgPrice(params) {
    return post(SERVICE_URL + '/quotation/insertZgPrice', params)
}
export function queryPurList(params) {
    return post(SERVICE_URL + '/quotation/queryPurList', params)
}
export function targetPurWorkList(params) {
    return post(SERVICE_URL + '/quotation/targetPurWorkList', params)
}
// 在 rfq.js 文件末尾添加以下方法

/** 寻源数据查询授权管理 */
export function queryXysqPage(params) {
    return post(SERVICE_URL + '/quotation/queryXysqPage', params)
}

export function insertXysq(params) {
    return post(SERVICE_URL + '/quotation/insertXysq', params)
}

export function queryPosList(params) {
    return post(SERVICE_URL + '/quotation/queryPosList', params)
}

export function deleteXysq(params) {
    return post(SERVICE_URL + '/quotation/deleteXysq', params)
}

export function queryUserList(params) {
    return post(SERVICE_URL + '/quotation/getAllUsers', params)
}
export function downLoadZipFile(params) {
    return postZip(SERVICE_URL + '/quotation/downLoadZipFile', params, {
        responseType: 'arraybuffer', // ✅ 必须设置！
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

